import React, { useState } from "react";
import { Switch, Input, Drawer, Form, Button, Image } from "antd";
import TextArea from "antd/es/input/TextArea";
import { requestWithImage } from "../../../functions/request";
import { uniKey, validData } from "../../../functions/functionsUtility";
import { toast } from "react-toastify";
import { Content } from "antd/es/layout/layout";

function ModalCapitulo(props) {
  const [capaImage, setCapaImage] = useState(null);
  const [thumbImage, setThumbImage] = useState(null);
  const saveData = async () => {
    const formData = new FormData();
    let dataAux = {
      cap_ativo: 0,
      cap_aberto: 0,
    };
    const canSave = await validData(props.contentModal, [
      "cap_nome",
      "cap_ordem",
    ]);
    if (!canSave) {
      toast.error("Preencha todos os campos obrigatórios! Campo: Nome, Ordem");
      return;
    }
    for (const key in props?.contentModal) {
      if (
        props?.contentModal[key] !== null &&
        props?.contentModal[key] !== undefined
      ) {
        dataAux[key] = props?.contentModal[key];
      }
    }
    dataAux.index = uniKey();
    const newData = JSON.stringify(dataAux);
    formData.append("newData", newData);
    if (capaImage !== null) {
      formData.append("cap_capa", capaImage);
    }
    if (thumbImage !== null) {
      formData.append("cap_thumb", thumbImage);
    }
    const response = await requestWithImage("/capitulos/insertCapitulo", {
      method: "POST",
      body: formData,
    })
      .then((res) => {
        toast.success("Série Salva com Sucesso!");
        props.onRequestClose();
        props.setContentModal({});
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      })
      .catch((err) => {
        console.log(err);
        toast.error("Erro ao Salvar Série!");
      });
  };

  const updateData = async () => {
    const formData = new FormData();
    let dataAux = {
      cap_ativo: 0,
      cap_aberto: 0,
    };
    const canSave = await validData(props.contentModal, [
      "cap_nome",
      "cap_ordem",
    ]);
    if (!canSave) {
      toast.error(
        "Preencha todos os campos obrigatórios! Campo: Nome, Ordem"
      );
      return;
    }
    for (const key in props?.contentModal) {
      if (
        props?.contentModal[key] !== null &&
        props?.contentModal[key] !== undefined
      ) {
        dataAux[key] = props?.contentModal[key];
      }
    }
    dataAux.index = uniKey();
    const newData = JSON.stringify(dataAux);
    formData.append("newData", newData);
    if (capaImage !== null) {
      formData.append("cap_capa", capaImage);
    }
    if (thumbImage !== null) {
      formData.append("cap_thumb", thumbImage);
    }
    const response = await requestWithImage(
      "/capitulos/updateCapitulo/" + props?.contentModal?.cap_id,
      {
        method: "PUT",
        body: formData,
      }
    )
      .then((res) => {
        toast.success("Série Salva com Sucesso!");
        props.onRequestClose();
        props.setContentModal({});
        // setTimeout(() => {
        //   window.location.reload();
        // }, 2000);
      })
      .catch((err) => {
        console.log(err);
        toast.error("Erro ao Salvar Série!");
      });
  };

  return (
    <>
      <Drawer
        title={
          props?.contentModal?.cap_id
            ? "Editar Capítulo"
            : "Adicionar Novo Capítulo"
        }
        open={props.isAddOpen}
        onClose={props.onRequestClose}
        extra={
          <Button
            type="primary"
            onClick={(el) => {
              !props?.contentModal?.cap_id
                ? saveData()
                : updateData();
            }}
          >
            Salvar
          </Button>
        }
      >
        <Form layout="vertical">
          <Form.Item label={"Título"}>
            <Input
              value={props.contentModal.cap_nome}
              onChange={(e) =>
                props.setContentModal({
                  ...props.contentModal,
                  cap_nome: e.target.value,
                })
              }
            />
          </Form.Item>
          <Form.Item label={"Descrição"}>
            <TextArea
              value={props.contentModal.cap_desc}
              onChange={(e) =>
                props.setContentModal({
                  ...props.contentModal,
                  cap_desc: e.target.value,
                })
              }
            />
          </Form.Item>
          <Form.Item label={"Capa"}>
            <Content
              style={{
                display: "flex",
                gap: 5,
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {props?.contentModal?.cap_capa && (
                <Image
                  src={`${process.env.REACT_APP_API_RB}/series/capitulos/${props?.contentModal?.cap_capa}`}
                  style={{ aspectRatio: "3 / 2", borderRadius: 8 }}
                  width={"80%"}
                />
              )}
              <Input
                onChange={(e) => setCapaImage(e.target.files[0])}
                type="file"
                accept="image/*"
              />
            </Content>
          </Form.Item>
          <Form.Item label={"Thumbnail"}>
            <Content
              style={{
                display: "flex",
                gap: 5,
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {props?.contentModal?.cap_thumb && (
                <Image
                  src={`${process.env.REACT_APP_API_RB}/series/capitulos/${props?.contentModal?.cap_thumb}`}
                  style={{ aspectRatio: "16 / 9", borderRadius: 8 }}
                  width={"80%"}
                />
              )}
              <Input
                onChange={(e) => setThumbImage(e.target.files[0])}
                type="file"
                accept="image/*"
              />
            </Content>
          </Form.Item>
          <Form.Item label={"Ordem (Ordem numerica 1, 2, 3 ...)"}>
            <Input
              value={props.contentModal.cap_ordem}
              onChange={(e) =>
                props.setContentModal({
                  ...props.contentModal,
                  cap_ordem: e.target.value.trim(),
                })
              }
            />
          </Form.Item>
          <Form.Item label={"Link do video"}>
            <Input
              value={props.contentModal.cap_cdn}
              onChange={(e) =>
                props.setContentModal({
                  ...props.contentModal,
                  cap_cdn: e.target.value,
                })
              }
              type="text"
            />
            </Form.Item>
            <Form.Item label={"Link Backup (Deixar em branco ou 0)"}>
            <Input
              value={props.contentModal.cap_video}
              onChange={(e) =>
                props.setContentModal({
                  ...props.contentModal,
                  cap_video: e.target.value,
                })
              }
              type="text"
            />
          </Form.Item>
          <Form.Item label={"Ativo"}>
            <Switch
              onChange={(e) =>
                props.setContentModal({ ...props.contentModal, cap_ativo: e })
              }
              checked={props.contentModal.cap_ativo}
            />
          </Form.Item>
          <Form.Item label={"Aberto"}>
            <Switch
              onChange={(e) =>
                props.setContentModal({
                  ...props.contentModal,
                  cap_aberto: e,
                })
              }
              checked={props.contentModal.cap_aberto}
            />
          </Form.Item>
        </Form>
      </Drawer>
    </>
  );
}

export default ModalCapitulo;
